module.exports = __webpack_public_path__ + "img/momip.0a10d969.png";